import FlagIcon from '@mui/icons-material/FlagOutlined';
import { generatePath } from 'react-router-dom';

import { RoutePath } from 'applications/GSP/shared/constants/router';
import { useFormatDateWithTimezone } from 'applications/GSP/shared/hooks/dates';
import {
  TitleCell,
  ValueCell,
  ArrowForwardCell,
  NavigationDataRow,
} from 'shared/components/DataRow';
import { formatDate } from 'shared/utils/date';

import type { InspiredGlobalStudyPlatformApiModelsAssignmentOverview as Assignment } from 'applications/GSP/shared/api/gsp';
import type { FC } from 'react';

export interface AssignmentRowProps extends Assignment {
  onClick(): void;
}

export const FLAG_ICON_TEST_ID = 'flag-icon';

export const AssignmentRow: FC<AssignmentRowProps> = ({
  id,
  subjectId,
  categoryName,
  subjectName,
  name,
  date,
  countsTowardsFinalGrade,
  onClick,
}) => {
  const formatDateWithTimeZone = useFormatDateWithTimezone(formatDate);

  return (
    <NavigationDataRow
      sx={{ gridTemplateColumns: '1fr auto auto' }}
      to={generatePath(RoutePath.AssignmentDetails, {
        subjectId,
        assignmentId: id,
      })}
      onClick={onClick}
    >
      <TitleCell
        aboveTitle={categoryName}
        title={subjectName}
        subtitle={name}
        startAdornment={
          countsTowardsFinalGrade && (
            <FlagIcon color="secondary" data-testid={FLAG_ICON_TEST_ID} />
          )
        }
      />
      <ValueCell label={date ? formatDateWithTimeZone(new Date(date)) : ''} />
      <ArrowForwardCell />
    </NavigationDataRow>
  );
};
